import { useEffect, useState } from 'react';
import { NavTabs } from './NavTabs';
import { Content } from './Content';
import { Logo } from './Logo';

export const HomePage = () => {
  const [activePage, setActivePage] = useState('home');
  useEffect(() => {
    if (window.navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
      window.location = getApi();
    } else {
      // window.location = "http://www.cxl1.cn/";
    }
  }, []);

  const getApi = () => {
    const hostname = window.location.hostname;
    const protocol = window.location.protocol;
    const port = window.location.port;

    // 如果是本地开发，返回固定的
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      // 本地开发时，可以根据需要修改
      return 'http://h5.xueli1.cn';
    }

    // 通用处理：将当前域名的第一个子域名替换为 'h5'
    const domainParts = hostname.split('.');

    // 确保域名至少有2部分（如 example.com）
    if (domainParts.length >= 2) {
      // 替换第一个部分为 'h5'
      domainParts[0] = 'h5';
      const newHostname = domainParts.join('.');

      // 如果有端口号，需要带上端口号（通常不需要，因为h5域名一般默认端口）
      // 但为了完整性，可以加上
      const portStr = port ? `:${port}` : '';

      return `${protocol}//${newHostname}${portStr}`;
    }

    // 如果域名解析失败，返回默认的（添加h5前缀）
    return `${protocol}//h5.${hostname}`;
  }

  return (
    <div className='bc_fff'>
      <Logo />
      <NavTabs setActivePage={setActivePage} />
      <Content activePage={activePage} setActivePage={setActivePage} />
    </div>
  );
}
